export default "__VITE_ASSET__BUdBsKm___"